import React, { useState, useCallback } from 'react';
import { DefaultTemplate } from 'views/templates/DefaultTemplate';
import { SAMLDomain } from 'models/SAML';
import { useIntl } from 'react-intl';
import { useAppDispatch } from 'stores/type';
import { setExceptionError } from 'stores/errorSlice';
import { SAMLLoginPageLayout } from 'views/layouts/SAMLLoginPageLayout';

export const SAMLLoginPage: React.FC = () => {
  const dispatch = useAppDispatch();
  const intl = useIntl();

  const [errorMessage, setErrorMessage] = useState<string | undefined>(
    undefined
  );

  const [disabledButton, setDisabledButton] = useState(false);

  const handleSubmit = useCallback((enterpriseName: string) => {
    setDisabledButton(true);
    SAMLDomain.loginURL(enterpriseName)
      .then((result) => {
        if (result.isFailure()) {
          setErrorMessage(intl.formatMessage({ id: result.value.localeId() }));
          setDisabledButton(false);
        } else {
          location.replace(result.value);
        }
      })
      .catch((e) => {
        dispatch(setExceptionError(e));
      });
  }, []);

  return (
    <DefaultTemplate headerText="DeployGate" showLogo>
      <SAMLLoginPageLayout
        onSamlLogin={handleSubmit}
        errorMessage={errorMessage}
        disabled={disabledButton}
      />
    </DefaultTemplate>
  );
};
